import "./Info.modules.scss";

import React, { Component } from "react";
import { connect } from "react-redux";

import InfoSlide from "./InfoSlide";
import { solarSystemConfig } from "../../assets/javascript/constants";
import { isPortrait } from "../../assets/javascript/utils";

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isArClicked: false,
      hasLoaded: false,
      canActivateAR: false,
      isArSupported: false,
      isPromiseDone: false,
    };

    this.infoSlideRef = React.createRef();
    this.arButtonRef = React.createRef();
    this.modelViewerRef = React.createRef();
  }

  componentDidMount() {
    const _canActivateAR =
      this.modelViewerRef.current.getAttribute("canactivatear") === "true";

    if (_canActivateAR) {
      document.querySelectorAll("html")[0].classList.add("-ar-enabled");
    }

    this.setState({
      canActivateAR: _canActivateAR,
    });

    this.modelViewerRef.current.addEventListener("load", () => {
      this.setState({
        hasLoaded: true,
      });
    });

    if (navigator.xr) {
      navigator.xr.isSessionSupported("immersive-ar").then((isSupported) => {
        this.setState({
          isArSupported: isSupported,
          isPromiseDone: true,
        });
      });
    }

    if (typeof localStorage.arSolarSystem !== "undefined") {
      const arSolarSystem = JSON.parse(localStorage.arSolarSystem);

      this.setState({
        isArClicked:
          typeof arSolarSystem.isArClicked === "undefined"
            ? false
            : arSolarSystem.isArClicked,
      });
    }
  }

  arButtonClicked() {
    if (!this.state.isArClicked) {
      this.setState(
        {
          isArClicked: true,
        },
        () => {
          localStorage.setItem(
            "arSolarSystem",
            JSON.stringify({
              isArClicked: true,
            })
          );
        }
      );
    }
  }

  render() {
    const {
      isArSupported,
      isArClicked,
      hasLoaded,
      canActivateAR,
      isPromiseDone,
    } = this.state;
    const { activePlanet } = this.props;
    const windowWidth = window.innerWidth;
    const infoWidth = windowWidth < 1024 ? windowWidth - 120 : windowWidth - 60;

    return (
      <div className={`info ${activePlanet === -1 ? "" : "-active"}`}>
        <div className="info__container">
          <div
            className="info__track"
            style={{
              left: -(activePlanet * infoWidth),
              width: solarSystemConfig.planets.length * infoWidth,
            }}>
            {solarSystemConfig.planets.map((planet, index) => (
              <InfoSlide
                key={index}
                data={planet}
                isArSupported={isArSupported}
                isArClicked={isArClicked}
                isPromiseDone={isPromiseDone}
                hasSolarSystemLoaded={hasLoaded}
                arButtonClicked={(event) => {
                  this.arButtonClicked(event);
                }}
                onClickViewSolarSystem={() => {
                  this.arButtonRef.current.click();
                }}
              />
            ))}
          </div>
        </div>

        <button
          className="info__orrery"
          type="button"
          onClick={() => {
            if (isPromiseDone) {
              if (isArSupported && hasLoaded && canActivateAR && isPortrait()) {
                this.arButtonRef.current.click();
              } else if (!isArSupported) {
                window.location = "/telescope/";
              }
            }
          }}>
          <model-viewer
            ref={this.modelViewerRef}
            src={`/assets/models/solar-system/source/solar-system.glb`}
            alt={`A 3D model of the Solar System`}
            ar
            ar-scale="auto"
            autoplay
            auto-rotate-delay="0"
            ar-modes="scene-viewer quick-look" // * Values: webxr scene-viewer quick-look
            seamless-poster
            shadow-intensity="0"
            loading="eager"
            canActivateAR>
            <div
              slot="ar-button"
              ref={this.arButtonRef}
              style={{ display: "none" }}>
              View in 3D
            </div>
          </model-viewer>
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activePlanet: state.activePlanet,
  };
};

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(Info);
